import React from 'react';

const Loader = () => {
  return (
    <div>
        <div id="loader" class="loader">
            <div class="loader-container"></div>ddddd
        </div>
    </div>
  );
}

export default Loader;
